import {
    COMMISSIONS_CREATE_POLICY_COPY_BEGIN,
    COMMISSIONS_CREATE_POLICY_COPY_SUCCESS,
    COMMISSIONS_CREATE_POLICY_COPY_FAILURE
  } from '../constants'
  
  export function reducer(state, action) {
    switch (action.type) {
      case COMMISSIONS_CREATE_POLICY_COPY_BEGIN:
        return {
          ...state,
          policies: {
            ...state.policies,
            createPolicyCopyPending: true,
            createPolicyCopySuccess: false,
            createPolicyCopyError: false,
          }
        }
  
      case COMMISSIONS_CREATE_POLICY_COPY_SUCCESS:
        return {
          ...state,
          policies: {
            ...state.policies,
            createPolicyCopyPending: false,
            createPolicyCopySuccess: true
          }
        }
  
      case COMMISSIONS_CREATE_POLICY_COPY_FAILURE:
        return {
          ...state,
          policies: {
            ...state.policies,
            createPolicyCopyPending: false,
            createPolicyCopyError: true
          }
        }
  
      default:
        return state
    }
  }
  